export const getTopLanguages = () => {
  return [
    { key: 'en', label: 'English', value: 'English' },
    { key: 'zh', label: 'Chinese', value: 'Chinese' },
    { key: 'hi', label: 'Hindi', value: 'Hindi' },
    { key: 'es', label: 'Castilian', value: 'Castilian' },
    { key: 'fr', label: 'French', value: 'French' },
    { key: 'ar', label: 'Arabic', value: 'Arabic' },
    { key: 'bn', label: 'Bengali', value: 'Bengali' },
    { key: 'ru', label: 'Russian', value: 'Russian' },
    { key: 'pt', label: 'Portuguese', value: 'Portuguese' },
    { key: 'id', label: 'Indonesian', value: 'Indonesian' },
    { key: 'ur', label: 'Urdu', value: 'Urdu' },
    { key: 'de', label: 'German', value: 'German' },
    { key: 'ja', label: 'Japanese', value: 'Japanese' },
    { key: 'sw', label: 'Swahili', value: 'Swahili' },
    { key: 'mr', label: 'Marathi', value: 'Marathi' },
    { key: 'ta', label: 'Tamil', value: 'Tamil' },
    { key: 'tr', label: 'Turkish', value: 'Turkish' },
    { key: 'vi', label: 'Vietnamese', value: 'Vietnamese' },
    { key: 'it', label: 'Italian', value: 'Italian' },
    { key: 'pl', label: 'Polish', value: 'Polish' },
    { key: 'nl', label: 'Flemish', value: 'Flemish' },
    { key: 'th', label: 'Thai', value: 'Thai' },
    { key: 'fa', label: 'Persian', value: 'Persian' },
    { key: 'ko', label: 'Korean', value: 'Korean' },
    { key: 'ro', label: 'Moldovan', value: 'Moldovan' },
    { key: 'ha', label: 'Hausa', value: 'Hausa' },
    { key: 'gu', label: 'Gujarati', value: 'Gujarati' },
    { key: 'kn', label: 'Kannada', value: 'Kannada' },
    { key: 'ml', label: 'Malayalam', value: 'Malayalam' },
    { key: 'or', label: 'Oriya', value: 'Oriya' },
  ]
}
